import React, { useEffect, useState } from "react";
import intl from "react-intl-universal";
import Push from "push.js";

import antennaRest from "../../rest/antennaRest";

import { Table } from "../components/Table";
import { Search } from "../components/Search";
import { Layout } from "../containers/Layout";
import { useDebounce } from "../hooks/useDebounce";
import { AntennaItem } from "./antennas/AntennaItem";
import { LazyScroll } from "../components/LazyScroll";
import { ContentBody } from "../containers/ContentBody";
import { ContentHeader } from "../containers/ContentHeader";

export const Antennas = () => {

    const [from, setFrom] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState(localStorage.getItem("antennaSearch") || "");

    const [antennas, setAntennas] = useState([]);

    const onLoadMore = async (antennas, from, pageSize, searchQuery) => {
        const recs = await antennaRest.getLazy(from, pageSize, searchQuery);
        if (recs === -1) {
            // something went wrong, for know we ignore this.
            return;
        }
        setFrom(recs.nextFrom ?? 0);
        setAntennas([...antennas, ...recs.list]);
        setHasMore(recs.hasMore);
        setLoading(false);
    };

    const onLoad = async (pageSize, searchQuery) => {
        setAntennas([]);
        setFrom(0);
        setHasMore(true);

        await onLoadMore([], 0, pageSize, searchQuery);
    };


    const onSearch = useDebounce((pageSize, searchQuery) => {
        setLoading(true);
        onLoad(pageSize, searchQuery);
    }, 500);

    useEffect(() => {
        Push.Permission.request();
        onSearch(60, searchQuery);
        // When many data are loaded and scroll is at the bottom, then the LazyScroll gets mad and loads
        // next page after next page, never stopping.
        // Reset scroll to the top fixes this issue.
        const content = document.getElementById("contentBody");
        if (content) {
            content.scrollTop = 0;
        }
    }, [searchQuery]);

    return (
        <Layout>
            <ContentHeader title={intl.get("navigation.antennas")}>
                <Search
                    id="antennaSearch"
                    value={searchQuery}
                    onChange={newVal => setSearchQuery(newVal)} />
            </ContentHeader>
            <ContentBody>
                <LazyScroll
                    id="antennaTable"
                    hasMore={hasMore}
                    loadMore={() => onLoadMore(antennas, from, 60, searchQuery)}
                    loading={loading}
                    text={intl.get("common.loadingText")}>
                    <Table>
                        <thead>
                            <tr>
                                <th width="10"></th>
                                <th width="400">{intl.get("antennas.manufacturer")}</th>
                                <th width="400">{intl.get("antennas.name")}</th>
                                <th width="190">{intl.get("antennas.originType")}</th>
                                <th width="400">{intl.get("antennas.mapping")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {antennas?.map(antenna =>
                                <AntennaItem key={antenna.id} antenna={antenna} />
                            )}
                        </tbody>
                    </Table>
                </LazyScroll>
            </ContentBody>
        </Layout>
    );
};